import { PREFIX } from "../../constant";

export const baseSeriesMark = {
    label: {
        name: "label",
        type: "text"
    }
};

export const RECT_X = `${PREFIX}_rect_x`;

export const RECT_X1 = `${PREFIX}_rect_x1`;

export const RECT_Y = `${PREFIX}_rect_y`;

export const RECT_Y1 = `${PREFIX}_rect_y1`;

export const defaultSeriesIgnoreCheckKeys = {
    data: !0
};

export const defaultSeriesCompileCheckKeys = {
    animation: !0,
    animationAppear: !0,
    animationEnter: !0,
    animationUpdate: !0,
    animationExit: !0,
    animationNormal: !0
};
//# sourceMappingURL=constant.js.map
